// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6c5534da","884":"f0638e1e"}[chunkId] + ".chunk.js";
};